import { useTranslation } from 'react-i18next'
import { useIsMobile } from '../../hooks/useIsMobile'
import './Manifesto.css'

export const Manifesto = () => {
    const { t } = useTranslation()
    const story = t('story', { returnObjects: true })
    const isMobile = useIsMobile()

    return (
        <div className='page-container'>
            <h2 className='manifesto-section-title fire-title'>{story.manifestoTitle}</h2>

            <div className='page-content-container'>
                <div className={`page-item ${!isMobile ? 'left' : ''}`}>
                    <div className='page-content'>
                        <p className='text-container'>{story.manifestoDesc}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
